import script from "./PopupContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupContainer.vue?vue&type=script&setup=true&lang=js"

import "./PopupContainer.vue?vue&type=style&index=0&id=abdb7264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abdb7264"]])

export default __exports__